import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { MeasuresFacade } from '@library/store/measures/measures.facade';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { ControlPageCardService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/control-page-card.service';
import { ConsumptionUnit, ControlPageStore } from '@pages/control-page/control-page-store.service';
import { combineLatest, filter, map, switchMap } from 'rxjs';

@Component({
  selector: 'app-home-elec-card',
  templateUrl: './home-elec-card.component.html',
  styleUrls: ['./home-elec-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeElecCardComponent {

  @Input() selected: boolean;

  private data$ = combineLatest({
    homeId: this.homesfacade.currentHomeId$.pipe(filter(id => !!id)),
    state: this.controlPageStore.state$,
  });

  private elec$ = this.data$.pipe(
    switchMap(({homeId, state: {scale, timeRange}}) => {
      return this.measuresFacade.getTimeRangeMeasuresTotal(
        homeId,
        [EnumMeasureTypes.SUM_ENERGY_BUY_FROM_GRID_BASE],
        this.controlPageStore.scaleToApiScale(scale),
        timeRange,
      );
    }),
  );

  private price$ = this.data$.pipe(
    switchMap(({homeId, state: {scale, timeRange}}) => {
      return this.measuresFacade.getTimeRangeMeasuresTotal(
        homeId,
        [EnumMeasureTypes.SUM_ENERGY_BUY_FROM_GRID_PRICE_BASE],
        this.controlPageStore.scaleToApiScale(scale),
        timeRange,
      );
    }),
  );

  private measureType$ = this.controlPageStore.homeConsumptionUnit$.pipe(
    map(unit => {
      return unit === ConsumptionUnit.CONSUMPTION
        ? EnumMeasureTypes.SUM_ENERGY_BUY_FROM_GRID_BASE
        : EnumMeasureTypes.SUM_ENERGY_BUY_FROM_GRID_PRICE_BASE;
    }),
  );

  vm$ = combineLatest({
    home: this.homesfacade.currentHome$,
    consumption: this.elec$,
    price: this.price$,
    measureType: this.measureType$,
    unit: this.controlPageStore.homeConsumptionUnit$,
  });

  EnumMeasureTypes = EnumMeasureTypes;

  constructor(
    private controlPageStore: ControlPageStore,
    private homesfacade: HomesFacade,
    private measuresFacade: MeasuresFacade,
    private controlPageCardService: ControlPageCardService,
  ) { }

  selectHomeElec(unit: ConsumptionUnit) {
    this.controlPageCardService.selectHomeElec(unit);
  }

}
